import { BrowserAgent } from '@newrelic/browser-agent';

let agent: BrowserAgent | null = null;

export function initNewRelicBrowserAgent(applicationID: string) {
    if (NewFeatures.AddNewRelicBrowserToWebGiving && applicationID) {
        agent = new BrowserAgent({
            init: {
                session_replay:{
                    enabled: true,
                    block_selector: '',
                    mask_text_selector: '*',
                    sampling_rate: 10.0,
                    error_sampling_rate: 100.0,
                    mask_all_inputs: true,
                    collect_fonts: true,
                    inline_images: false,
                    ...({ inline_stylesheet: true } as any), // missing from the type definition
                    fix_stylesheets: true,
                    preload: false,
                    mask_input_options: {},
                },
                distributed_tracing:{
                    enabled: true,
                },
                privacy: {
                    cookies_enabled: true,
                },
                ajax: {
                    deny_list: ['bam.nr-data.net'],
                },
                feature_flags: ['soft_nav'],
            },
            info: {
                beacon: 'bam.nr-data.net',
                errorBeacon: 'bam.nr-data.net',
                licenseKey: 'NRJS-84795264ae84f09ec93',
                applicationID,
                sa: 1,
            },
            loader_config: {
                accountID: '2673924',
                trustKey: '2673924',
                agentID: '1134610278',
                licenseKey: 'NRJS-84795264ae84f09ec93',
                applicationID,
            },
        });
    } else {
        const noop = () => {};
        const handler: ProxyHandler<BrowserAgent> = {
            get() {
                return noop;
            }
        };
        agent = new Proxy({} as BrowserAgent, handler);
    }    
}

export function getNewRelicBrowserAgent() {
    if (!agent) {
        throw new Error('New Relic Browser Agent is not initialized. Call initNewRelicBrowserAgent first.');
    }
    return agent;
}

